export default __webpack_public_path__ + "static/media/express.4925c012.svg";